var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"YouTube"),React.createElement("path",{"fillRule":"evenodd","d":"M20.433 6c2.23.01 12.422.093 15.195.841a5.025 5.025 0 013.536 3.56C40 13.54 40 20.09 40 20.09c0 .271-.017 6.616-.836 9.69a5.026 5.026 0 01-3.536 3.56c-2.823.76-13.33.833-15.307.84h-.643c-1.976-.007-12.484-.08-15.306-.84a5.027 5.027 0 01-3.536-3.56C.086 26.968.009 21.418 0 20.293v-.404c.008-1.126.086-6.676.835-9.489a5.026 5.026 0 013.536-3.559c2.773-.748 12.964-.83 15.195-.84zm-4.524 8.143v11.895l10.455-5.947-10.455-5.948z","key":1})]);
}

Youtube.defaultProps = {"fill":"#D9252A","viewBox":"0 0 40 40"};

module.exports = Youtube;

Youtube.default = Youtube;
